import './App.css';
import CountdownTimer from "./CountdownTimer";


function App() {
  function getValueFromQueryOrDefault(queryParameterName, defaultValue) {
    const queryParams = new URLSearchParams(window.location.search);
    const queryValue = parseInt(queryParams.get(queryParameterName));
    if (queryValue > 0) {
      return queryValue;
    }
    return defaultValue;
  }

  const duration = getValueFromQueryOrDefault("duration", 600);
  const threshold = getValueFromQueryOrDefault("threshold", 120);

  return (
    <div className="App">
      <CountdownTimer duration={duration} threshold={threshold}></CountdownTimer>
    </div>
  );
}

export default App;
